import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import getCTAProps from '@utils/cta';
import Block from '@components/block/Text/Block';
import Button from '@components/Button';
import Image from '@components/Image';
import SizedImage from '@components/SizedImage';
import { getImageHeight } from '@utils/space';

import * as styled from './styles';

function ImageTextBlock({ title, titleTheme, text, button, imageAlignment, imagesExtended, imageOrientation, imageHeight }) {
  const isSized = Boolean(getImageHeight(imageHeight));

  return (
    <styled.Wrapper>
      <styled.Inner align={imageAlignment}>
        <styled.ImagesContainer orientation={imageOrientation} $sized={isSized}>
          {imagesExtended.length > 0 &&
            imagesExtended.map((item, idx) => (
              isSized ? (
                <SizedImage key={idx} fluid={item.asset.fluid} altText={item.altText} imageHeight={imageHeight}
                            orientation={imageOrientation}>
                  {item.credit && <styled.Credit>{item.credit}</styled.Credit>}
                </SizedImage>
              ) : (
                <styled.ImageWrapper key={idx} orientation={imageOrientation}>
                  <Image fluid={item.asset.fluid} altText={item.altText}
                         ratio={imageOrientation === 'portrait' ? 1.333 : 0.5625} />
                  {item.credit && <styled.Credit>{item.credit}</styled.Credit>}
                </styled.ImageWrapper>
              )
            ))}
        </styled.ImagesContainer>

        <styled.Content>
          <styled.Title colorTheme={titleTheme} levels={[200]}>
            {title}
          </styled.Title>
          {Array.isArray(text) &&
            text.map((part, idx) => (
              <styled.TextWrapper key={idx}>
                <Block content={part} />
              </styled.TextWrapper>
            ))}
          {get(button, 'label') && (
            <Button appearance={button.colorTheme} fill {...getCTAProps(button)}>
              {button.label}
            </Button>
          )}
        </styled.Content>
      </styled.Inner>
    </styled.Wrapper>
  );
}

ImageTextBlock.propTypes = {
  title: PropTypes.string,
  titleTheme: PropTypes.oneOf(['blue', 'green', 'orange', 'purple', 'yellow']),
  text: PropTypes.string,
  button: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
    colorTheme: PropTypes.oneOf(['blue', 'green', 'orange', 'purple', 'yellow']),
  }),
  imagesExtended: PropTypes.arrayOf(PropTypes.object).isRequired,
  imageAlignment: PropTypes.oneOf(['right', 'left']),
  imageOrientation: PropTypes.oneOf(['album', 'portrait']),
  imageHeight: PropTypes.oneOf(['small', 'medium', 'large']),
};

ImageTextBlock.defaultProps = {
  imageAlignment: 'right',
  imageOrientation: 'album',
};

export default ImageTextBlock;
